import React, { useEffect, useState } from 'react';

import { Web } from '@mui/icons-material';
import { API } from 'aws-amplify';
import { FaCubes } from 'react-icons/fa';
import {
  MdNoteAdd,
  MdBuildCircle,
  MdFolderShared,
  MdForwardToInbox,
  MdHourglassTop,
  MdQuestionAnswer,
  MdCheckCircleOutline,
  MdHighlightOff,
  MdListAlt,
  MdFileCopy,
  MdManageAccounts,
  MdDoDisturb,
  MdSearch,
} from 'react-icons/md';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { setRoleId } from './driverQualificationSlice';
import { Tile, TileGrid, SubHeader, Footer } from '../../components';
import { getDriverQualificationRoleId } from '../../graphql/customQueries';

import './styles.scoped.css';

export const iconMap = {
  note_add: MdNoteAdd,
  build_circle: MdBuildCircle,
  folder_shared: MdFolderShared,
  forward_to_inbox: MdForwardToInbox,
  hourglass_top: MdHourglassTop,
  question_answer: MdQuestionAnswer,
  check_circle_outline: MdCheckCircleOutline,
  highlight_off: MdHighlightOff,
  list_alt: MdListAlt,
  file_copy: MdFileCopy,
  manage_accounts: MdManageAccounts,
  do_disturb: MdDoDisturb,
  search: MdSearch,
  cubes: FaCubes,
};

const getIcon = name => {
  const Icon = iconMap[name];
  return Icon ? <Icon size={36} color="#da0f2e" /> : null;
};

const DriverQualification = () => {
  const header = useSelector(state => state.driverQualification.header);
  const clientMenu = useSelector(state => state.driverQualification.clientMenu);
  const corporateMenu = useSelector(state => state.driverQualification.corporateMenu);
  const managementMenu = useSelector(state => state.driverQualification.managementMenu);
  const id = useSelector(state => state.admin.user.id);
  const roleId = useSelector(state => state.driverQualification.roleId);
  const [usedBy, setUsedBy] = useState('');
  const [appId, setAppId] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onPress = item => {
    navigate(item.to);
  };

  useEffect(() => {
    if (!id) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const response = await API.graphql({
          query: getDriverQualificationRoleId,
          variables: { id },
        });
        if (cancelled) return;
        response?.data?.getUser?.appAccess?.items?.forEach(item => {
          dispatch(setRoleId(item.roleId.id));
          setAppId(item?.appId.id);
          setUsedBy(item?.roleId?.usedBy);
        });
      } catch (e) {
        console.log('error', e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id]);

  return (
    <>
      <SubHeader
        text="Centerline Driver Qualification"
        buttons={[{ icon: <Web sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/dashboard') }]}
        popoverTitle="Need help with your driver qualification?"
      />
      <div className="wrap">
        <h1 className="header">{header}</h1>

        {appId === `${2}` && usedBy === 'Client'
          ? clientMenu.map(item => {
              const statusItems = item.items.filter(i => i.icon !== 'search');
              const searchItem = item.items.find(i => i.icon === 'search');
              return (
                <div key={item.header}>
                  <TileGrid>
                    {statusItems.map(i => (
                      <Tile key={i.icon} icon={getIcon(i.icon)} text={i.text} onPress={() => onPress(i)} />
                    ))}
                    {searchItem && (
                      <div style={{ gridColumn: 2 }}>
                        <Tile key={searchItem.icon} icon={getIcon(searchItem.icon)} text={searchItem.text} onPress={() => onPress(searchItem)} />
                      </div>
                    )}
                  </TileGrid>
                </div>
              );
            })
          : null}

        {(appId === `${2}` && roleId === `${10}`) || (appId === `${2}` && roleId === `${3}`)
          ? corporateMenu.map(item => {
              const statusItems = item.items.filter(i => i.icon !== 'search');
              const searchItem = item.items.find(i => i.icon === 'search');
              return (
                <div key={item.header}>
                  <TileGrid>
                    {statusItems.map(i => (
                      <Tile key={i.icon} icon={getIcon(i.icon)} text={i.text} onPress={() => onPress(i)} />
                    ))}
                    {searchItem && (
                      <div style={{ gridColumn: 2 }}>
                        <Tile key={searchItem.icon} icon={getIcon(searchItem.icon)} text={searchItem.text} onPress={() => onPress(searchItem)} />
                      </div>
                    )}
                  </TileGrid>
                </div>
              );
            })
          : null}
        {/* TODO: remove trailing or */}
        {appId === `${2}` && roleId === `${10}` && usedBy === 'Corporate'
          ? managementMenu.map(item => (
              <div key={item.header}>
                <h1 key={`${item.header}-h1`} className="header">
                  {item.header}
                </h1>
                <TileGrid>
                  {item.items.map(i => (
                    <Tile key={i.icon} icon={getIcon(i.icon)} text={i.text} onPress={() => onPress(i)} />
                  ))}
                </TileGrid>
              </div>
            ))
          : null}
      </div>
      <Footer />
    </>
  );
};

export default DriverQualification;
